/* global hUrl */
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-ppv')) {
  pagePpv()
}
function pagePpv() {
  //  ##  ###    ###    ###     ####    #####
  //  ##  ## #  # ##   ## ##   ##       ##
  //  ##  ##  ##  ##  ##   ##  ##  ###  #####
  //  ##  ##      ##  #######  ##   ##  ##
  //  ##  ##      ##  ##   ##   ####    #####
  if (document.getElementById('imageSlide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('imageSlide')
    const sliderName = 'imageSlide'
    const imageSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（imageSlideSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      autoHeight: true, // スライドごとに高さを変動させる
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })

    let lastSlide = null
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ
      if (e.target.classList.contains('js-slideShift')) {
        const slide = parseInt(e.target.dataset.slide, 10)
        if (lastSlide === slide) {
          return
        }
        imageSlideSwiper.slideTo(slide)
        imageSlideSwiper.slideNext()
        lastSlide = slide
      }
    })
  }
}
